let footer = document.querySelector('footer')
if (footer) {
  let footerHeight = footer.offsetHeight
  document.body.style.paddingBottom = `${footerHeight}px`
}